<template>
  <div id="accordion">
    <div
      style="
        font-size: 20px;
        margin: 13px 0 18px 0px;
        border-bottom: 2px solid darkred;
        padding-bottom: 8px;
      "
    >
      Holdings
    </div>

    <a-input
      v-model:value="params.holdingName"
      placeholder="Rechercher ..."
      size="large"
      allow-clear
    />

    <div v-if="showSearchedHoldings" id="searched_holdings">
      <div v-if="loading" style="text-align: center">
        <a-spin />
      </div>

      <div
        v-if="!loading && _searchedHoldings.length == 0"
        style="text-align: center"
      >
        No data
      </div>

      <div v-for="h in searchedHoldings" :key="h.uuid">
        <div class="searched_holding" :style="[h.isSelected ? {backgroundColor: '#eaffdf'} : {}]">
          {{ h.name }}
          <span
            v-if="!h.isSelected"
            @click="addHolding(h)"
            class="searched_holding_select"
          >
            +
          </span>
          <span
            v-if="h.isSelected"
            @click="removeHolding(h)"
            class="searched_holding_remove"
          >
            X
          </span>
        </div>
      </div>
    </div>
    <a-divider></a-divider>

    <div
      class="searched_holding"
      style="background-color: #eaffdf"
      v-for="sh in params.holdings"
      :key="sh.uuid"
    >
      {{ sh.name }}

      <span @click="removeHolding(sh)" class="searched_holding_remove">
        X
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtractionHoldings",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      _searchedHoldings: [],

      loading: false,
      timeout: 0,
    };
  },
  watch: {
    _searchValue(value) {
      this._searchedHoldings = [];
      this.loading = true;
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        if (value != "") {
          this.findHoldings();
        }
      }, 500);
    },
  },
  methods: {
    findHoldings() {
      this.loading = true;

      if(this.params.holdingName.trim().length === 0){
        return
      }

      // this.params.contract_type = this.params.spa + this.params.er;
      // this.params.selected_holdings = JSON.stringify(this.params.holdings)

      this.axios
        .get(`data/holdings/${this.spaEr}/?${new URLSearchParams(this.params)}`)
        .then((r) => {
          if (r.status === 200) {
            this.loading = false;

            this._searchedHoldings = r.data;

            setTimeout(() => {
              this.loading = false;
            }, 100);
          }
        });
    },
    addHolding(holding) {
      this.params.holdings.push(holding);
      this.params.holdingName = "";
    },
    removeHolding(holding) {
      this.params.holdings = this.params.holdings.filter(
        (h) => h.uuid != holding.uuid
      );
    },
    prepareExcelData() {
      var excelData = [];
      this.$store.state.holdings.filter(function (h) {
        h.entreprises.forEach((e) => {
          if (e.ck) excelData.push(e.nuC);
        });
      });
      return excelData;
    },
    prepareExcelFile() {
      this.$emit("prepare-excel-file", {
        type: this.extType,
        list: this.prepareExcelData(),
        count: 1,
      });
    },
  },
  computed: {
    extType() {
      if (this.$route.params.extType === undefined) return false;
      return this.$route.params.extType;
    },
    searchedHoldings() {
      return this._searchedHoldings.filter((sh) => {
        sh.isSelected = this.params.holdings.some((h) => h.uuid == sh.uuid);

        return sh;
      });
    },

    showSearchedHoldings() {
      return this._searchValue ? true : false;
    },
    _searchValue() {
      return this.params.holdingName;
    },
    spaEr() {
      return this.params.spa + this.params.er;
    },
  },
};
</script>

<style>
div#searched_holdings {
  box-shadow: 0 0 5px 0 #bcbcbc;
  background-color: #ffffff;
  padding: 10px;
  margin-top: 6px;
  border-radius: 4px;
}
.searched_holding {
  position: relative;
  /* display: inline-block; */
  padding: 4px 42px 4px 12px;
  border-radius: 50px;
  margin: 4px;
  background-color: #f1f1f1;
}

.searched_holding_select {
  position: absolute;
  right: 13px;
  font-size: 28px;
  top: -7px;
  color: green;
  cursor: pointer;
}
.searched_holding_remove {
  position: absolute;
  right: 16px;
  font-size: 14px;
  top: 4px;
  color: red;
  cursor: pointer;
  font-weight: bold;
}
div#accordion {
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
  margin-left: 10px;
  width: 540px;
}

.spinner {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  -webkit-animation: sk-rotate 2s infinite linear;
  animation: sk-rotate 2s infinite linear;
}
.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #c70038;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}
.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}
@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>
